import { Stack, Typography } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid-premium";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { EmailTrackingItem } from "../../../../../api/types/documentCollectionTypes";
import EmailStatus from "../../../../tables/EmailStatus";

interface RecipientProps {
  recipientName: string;
  email: string;
}

const Recipient = ({ recipientName, email }: RecipientProps) => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
    <UserAvatar size="medium" userName={recipientName} />
    <Stack spacing={0.5}>
      <Typography variant="subtitle2">{recipientName}</Typography>
      <Typography variant="caption">{email}</Typography>
    </Stack>
  </Stack>
);

const columnDefinitions: GridColDef<EmailTrackingItem>[] = [
  {
    field: "recipientName",
    headerName: "Recipient",
    flex: 2,
    renderCell: ({ row }) => <Recipient recipientName={row.recipientName ?? ""} email={row.email ?? ""} />,
  },
  {
    field: "investor",
    headerName: "Investor",
    flex: 2,
  },
  {
    field: "subject",
    headerName: "Subject",
    flex: 2,
  },
  {
    field: "sentAt",
    headerName: "Sent",
    flex: 1,
    renderCell: ({ row }) => (
      <Typography variant="caption" color="textSecondary">
        {convertISODateTime(row.sentAt)}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    renderCell: ({ row }) => (
      <EmailStatus
        status={row.status}
        deliveryFailureMessage={row.deliveryFailureMessage}
        deliveryFailureMessageExplanation={row.deliveryFailureMessageExplanation}
      />
    ),
  },
];

interface Props {
  emails: EmailTrackingItem[];
}

const EmailsViewGrid = ({ emails }: Props) => {
  return (
    <DataGrid<EmailTrackingItem>
      columns={columnDefinitions}
      rows={emails}
      multilineRows
      disableColumnSorting
      disableColumnReorder
    />
  );
};

export default EmailsViewGrid;
